/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import Search from '../searchComponents/Search';
import DatahubAPI from '../../../api/DatahubAPI';
import EntityServiceAPI from '../../../api/EntityServiceAPI';
import { Redirect } from 'react-router-dom';
import { Modal } from '@mui/material';
import DateSelector from '../filters/DateSelector';
import { format } from 'date-fns';

interface ICyberProps {
  setShowFullRecord: any;
  showFilters: boolean;
  cur_user: any;
  userHasCyberSearch: boolean;
  inputs: any;
  setInputs: any;
  page: number;
  setPage: any;
}

const Cyber: React.FC<ICyberProps> = ({
  inputs,
  setInputs,
  page,
  setPage,
  userHasCyberSearch,
  cur_user,
  setShowFullRecord,
}) => {
  const isInteractionDisabled = !userHasCyberSearch;
  const [cyberState, setCyberState] = useState({
    fuzzy: true,
    archived: false,
    date: null,
    dateRange: [],
  });
  const [cyberReturns, setCyberReturns] = useState<any>({
    isLoading: true,
    data: [],
  });
  const [submit, setSubmit] = useState<boolean>(false);
  const [cyberTab, setCyberTab] = useState('Trade');
  const [indices, setIndices] = useState(['Alerts']);
  const [cyberHeaders, setCyberHeaders] = useState<string[]>([
    'Intervention Type',
    'HS Code',
    'Implementing Jurisdictions',
    'Risk Country',
    'GTA Evaluation',
  ]);
  const [openDate, setOpenDate] = useState(false);
  const [frequency, setFrequency] = useState('Once');
  const [shareEmail, setShareEmail] = useState<string[]>([]);
  const [ticketNameOpen, setTicketNameOpen] = useState(false);
  const [newTicketName, setNewTicketName] = useState<string>('');
  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleTabSwitch = (newTab: string) => {
    if (isInteractionDisabled) {
      return;
    }
    setInputs([
      {
        primary: '',
      },
    ]);
    switch (newTab) {
      case 'Trade':
        setCyberHeaders([
          'Intervention Type',
          'HS Code',
          'Implementing Jurisdictions',
          'Risk Country',
          'GTA Evaluation',
        ]);
        setCyberTab('Trade');
        setIndices(['Alerts']);
        setSubmit(!submit);
        break;
      case 'CVE':
        setCyberHeaders([
          'CVE ID',
          'Vendor Project',
          'Product',
          'Vulnerability Name',
          'Required Action',
        ]);
        setCyberTab('CVE');
        setIndices(['Cyber_Protection_KEV_Alias']);
        setSubmit(!submit);
        break;
      case 'Markets':
        setCyberHeaders([
          'Market Name',
          'Description',
          'Website',
          'Market Location',
        ]);
        setCyberTab('Markets');
        setIndices(['Cyber_Protection_Notorious_Markets_Alias']);
        setSubmit(!submit);
        break;
      default:
        setCyberTab('Trade');
    }
  };

  const getCyCSVResults = async (queryInputs: any, pageNum: number) => {
    if (isInteractionDisabled) {
      return [];
    }
    const allResults: any = [];
    const query: any = {
      primary: inputs.cyber,
      indices: indices,
      pageNum: pageNum,
      dateRange: cyberState.dateRange,
      fuzziness: cyberState.fuzzy ? 'AUTO' : 0,
      qty: 200,
    };
    if (cyberTab === 'Trade') {
      query.listName = ['Global Trade Alerts'];
    }
    const res = await EntityServiceAPI.entitySearch(query);
    if (res?.success) {
      allResults.push(res?.result);
    }
    return allResults;
  };

  const handleSubmit = async (pageNum: number) => {
    if (isInteractionDisabled) {
      setCyberReturns({ isLoading: false, data: [] });
      return;
    }
    setCyberReturns({ isLoading: true, data: [] });
    const allResults: any = [];
    const query: any = {
      primary: inputs.cyber,
      indices: indices,
      pageNum: pageNum,
      dateRange: cyberState.dateRange,
      fuzziness: cyberState.fuzzy ? 'AUTO' : 0,
    };
    if (cyberTab === 'Trade') {
      query.listName = ['Global Trade Alerts'];
      query.indexName = 'Alerts';
      const res = await DatahubAPI.trade(query);
      if (res?.success) {
        allResults.push(res?.result);
      }
    } else {
      const res = await DatahubAPI.cyberSearch(query);
      if (res?.success) {
        allResults.push(res?.result);
      }
    }
    // const res = await DatahubAPI.cyberSearch(query);
    // if (res?.success) {
    //   allResults.push(res?.result);
    // }

    setCyberReturns({ isLoading: false, data: allResults });
  };

  const handleMultiPageChange = async (
    input: any,
    pageNum: number,
    i: number,
  ) => {
    if (isInteractionDisabled) {
      return;
    }
    setCyberReturns({ isLoading: true, data: [] });
    const allResults: any = cyberReturns.data;
    const query: any = {
      primary: input,
      indices: indices,
      pageNum: pageNum,
      dateRange: cyberState.dateRange,
      fuzziness: cyberState.fuzzy ? 'AUTO' : 0,
    };
    if (cyberTab === 'Trade') {
      query.listName = ['Global Trade Alerts'];
    }
    const res = await EntityServiceAPI.entitySearch(query);
    if (res?.success) {
      allResults[i] = res?.result;
    }
    setCyberReturns({ isLoading: false, data: allResults });
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isInteractionDisabled) {
      return;
    }
    setCyberState({ ...cyberState, fuzzy: event.target.checked });
  };

  const handleDateChange = (newValue: any) => {
    if (isInteractionDisabled) {
      return;
    }
    const arr: any = [...newValue];
    if (newValue[0] !== null) {
      arr.forEach((dt: any, index: number) => {
        if (dt !== null) {
          const dtWithoutTz = new Date(
            dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000,
          );
          const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
          arr[index] = formatted_dt;
        }
      });
      setCyberState({ ...cyberState, date: newValue, dateRange: arr });
    } else {
      setCyberState({ ...cyberState, date: null, dateRange: [] });
    }
  };

  useEffect(() => {
    if (isInteractionDisabled) {
      return;
    }
    handleSubmit(0);
  }, [cyberTab, submit, isInteractionDisabled]);

  useEffect(() => {
    setPage(0);
  }, [inputs]);

  useEffect(() => {
    if (isInteractionDisabled) {
      setCyberReturns({ isLoading: false, data: [] });
    }
  }, [isInteractionDisabled]);

  return (
    <div className='screening-body-container'>
      <Search
        userHasSearch={userHasCyberSearch}
        setShowFullRecord={setShowFullRecord}
        type={'Cyber'}
        handleSubmit={handleSubmit}
        inputs={inputs}
        setInputs={setInputs}
        results={cyberReturns}
        page={page}
        setPage={setPage}
        cyberTab={cyberTab}
        handleTabSwitch={handleTabSwitch}
        cyberHeaders={cyberHeaders}
        getCSVResults={getCyCSVResults}
        handleMultiPageChange={handleMultiPageChange}
        state={cyberState}
        handleSwitchChange={handleSwitchChange}
        handleOpenDate={() => setOpenDate(true)}
        shareEmail={shareEmail}
        setShareEmail={setShareEmail}
        setFrequency={setFrequency}
        frequency={frequency}
        ticketNameOpen={ticketNameOpen}
        setTicketNameOpen={setTicketNameOpen}
        newTicketName={newTicketName}
        setNewTicketName={setNewTicketName}
        isInteractionDisabled={isInteractionDisabled}
      />
      <Modal open={openDate} onClose={() => setOpenDate(false)}>
        <DateSelector
          openDate={openDate}
          setOpenDate={setOpenDate}
          state={cyberState}
          handleDateChange={handleDateChange}
          setSubmit={setSubmit}
          submit={submit}
        />
      </Modal>
    </div>
  );
};

export default Cyber;
